export default __webpack_public_path__ + "static/test-image-3-080c500db3494426401f1fcda89606aa.jpg";